/**
 * [Pure] Get method names from the prototype of an object / class.
 * @param obj - Object / class to get methods from.
 */
export function getMethodNames(obj: any): Array <string> {
    const proto = Object.getPrototypeOf(obj);                                           // Get prototype of object / class.
    const props = Object.getOwnPropertyNames(proto);                                    // Get properties from prototype.
    return props.filter(key => obj[key] instanceof Function && key !== "constructor");  // Filter for methods.
}
